module.exports = __webpack_public_path__ + "img/seal.733ff78c.png";